import {
  Component, Input, Output, EventEmitter, OnInit,
  AfterViewInit, AfterViewChecked, ElementRef
} from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TermsContentService } from './terms-content.service';
import { HttpResponse } from '@angular/common/http';
declare var initAriaHidden: any;
declare var removeAriaHidden: any;

const ESCAPE_KEY = 27;
const TAB_KEY_CODE = 9;
const businessUrl = '/businessconsole';

@Component({
  selector: 'app-terms-content',
  templateUrl: './terms-content.component.html',
  styleUrls: ['./terms-content.component.scss'],
  providers: [TermsContentService],

})
export class TermsContentComponent implements OnInit {

  errorMsg: string;
  termsContentHtml: string;

  @Input() showModal: boolean;
  @Input() title: string;


  @Input() set contentUrl(url: string) {
    if (url !== undefined && url !== '') {
      let appendWithBusinessUrl = businessUrl + url.substr(url.indexOf('/assets'), url.length);
      this.termsConditionService.fetchtnc(appendWithBusinessUrl)
        .subscribe( (tncText: HttpResponse<any>) => {
          this.termsContentHtml = tncText.body; // Todo comments
          console.log(this.termsContentHtml);
          // this.modelTitle = "My lucy project";
        },
        error => {
          document.body.classList.remove('modal-open');
          this.showModal = false;
          this.handleError(error);
        });
    }
  }

  @Input() triggerElement: any;

  @Output()
  modalOutput: EventEmitter<boolean>;

  @Output()
  modalErrorMsg: EventEmitter<string>;

  focusabbleElements: any;

  constructor(protected router: Router, private el: ElementRef,
    private termsConditionService: TermsContentService) {
    this.modalOutput = new EventEmitter<boolean>();
    this.showModal = false;
    this.title = undefined;
  }

  ngOnInit() {
    document.body.classList.add('modal-open');
    initAriaHidden();
  }

  btnAction() {
    document.body.classList.remove('modal-open');
    removeAriaHidden();
    this.focusabbleElements = undefined;
    if (this.triggerElement) {
      this.triggerElement.focus();
    }
    this.modalOutput.emit(false);
  }


  handleKeydown(event) {
    const focussedEl = event.target;
    if (event.keyCode === ESCAPE_KEY) {
      this.btnAction();
      return;
    }
    if (event.shiftKey && event.keyCode === TAB_KEY_CODE) {
      if (focussedEl === this.focusabbleElements[0]) {
        event.preventDefault();
        this.focusabbleElements[this.focusabbleElements.length - 1].focus();
      }
    } else if (event.keyCode === TAB_KEY_CODE) {
      console.log(this.focusabbleElements);

      if (focussedEl === this.focusabbleElements[this.focusabbleElements.length - 1]) {
        event.preventDefault();
        // this.focusabbleElements[0].focus();
        document.getElementById('modalHeading').focus();
      }
    }
  }

  loadFocustelements() {
    if (!this.focusabbleElements) {
      const focusableEls = this.el.nativeElement.
        querySelectorAll('a[href], area[href],' +
        ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
      this.focusabbleElements = Array.prototype.slice.call(focusableEls);
      // this.focusabbleElements[0].focus();
      document.getElementById('modalHeading').focus();
    }
  }


  handleError(error) {
    if (error.status === 500) {
      this.errorMsg = 'Invalid CTN. Please try again!';
      this.modalErrorMsg.emit(this.errorMsg);
    } else {
      this.errorMsg = 'Unable to load';
      this.modalErrorMsg.emit(this.errorMsg);
      throw error;
    }
  }
}
